import { render, staticRenderFns } from "./CeeYuuFooter.vue?vue&type=template&id=47209154&scoped=true"
import script from "./CeeYuuFooter.vue?vue&type=script&lang=js"
export * from "./CeeYuuFooter.vue?vue&type=script&lang=js"
import style0 from "./CeeYuuFooter.vue?vue&type=style&index=0&id=47209154&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47209154",
  null
  
)

export default component.exports